import produce from 'immer';
import {
  SEND_DNS_CONFIGURATIONS_START,
  SEND_DNS_CONFIGURATIONS_SUCCESS,
  SEND_DNS_CONFIGURATIONS_FAILED,
  VERIFY_DNS_CONFIGURATIONS_START,
  VERIFY_DNS_CONFIGURATIONS_SUCCESS,
  VERIFY_DNS_CONFIGURATIONS_FAILED,
} from '../actions/dns_manager';


const initialState = {
  sendingDNSConfigurations: false,
  verifyingDNSConfigurations: false
};

const formReducer = produce((state = initialState, action) => {
  switch (action.type) {
    case SEND_DNS_CONFIGURATIONS_START: {
      state.sendingDNSConfigurations = true;
      break;
    }
    case SEND_DNS_CONFIGURATIONS_SUCCESS: {
      state.sendingDNSConfigurations = false;

      break;
    }
    case SEND_DNS_CONFIGURATIONS_FAILED: {
      state.sendingDNSConfigurations = false;
      break;
    }
    case VERIFY_DNS_CONFIGURATIONS_START: {
      state.verifyingDNSConfigurations = true;
      break;
    }
    case VERIFY_DNS_CONFIGURATIONS_SUCCESS: {
      state.verifyingDNSConfigurations = false;
      break;
    }
    case VERIFY_DNS_CONFIGURATIONS_FAILED: {
      state.verifyingDNSConfigurations = false;
      break;
    }
    default:
      break;
  }
}, initialState);

export default formReducer;
